export default __webpack_public_path__ + "menu-customers-icon.36532e1447af3350858044965c97d403.svg";